import React from "react";

const Pending = ({ singleAd }) => {
  return (
    <div
      style={{
        zIndex: 1,
        width: "100px",
        height: "25px",
        position: "absolute",
        top: 0,
        left: singleAd ? 12: 0,
        borderRadius: "5px",
      }}
      className="text-white text-center bg-danger"
    >
      Pending
    </div>
  );
};

export default Pending;
